var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-main"},[_c('AuthLeftSideComponent'),_c('div',{staticClass:"auth-right"},[_c('div',{staticClass:"right-main d-flex flex-column h-100"},[_c('RightHeaderComponent'),_vm._t("default"),_c('RightFooterComponent')],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }